import angular from 'angular';

export const viewsModule = angular.module(
  'portainer.kubernetes.react.views',
  []
).name;
